import { Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { AuthCallbackPath } from "../../../api-types/connector-callbacks";
import { BigcommerceConnectOtp } from "../../../components";
import { ConnectorNavigationGroup } from "../../../components/connect/common/navigation-group";
import { usePlatformConnectorProperties } from "../../../hooks/connector";
import { ConnectorPageTemplate } from "../components";

import { MESSAGES } from "./message-definitions";

const CONNECTOR_SLUG = "bigcommercerutter";

const BigcommerceConnectWithNav = () => {
  const postConnectPath = AuthCallbackPath.FUNDING_APPLICATION_ADD_CONNECTION;
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(customerDomain, CONNECTOR_SLUG, postConnectPath);
  const hasConnections = !!connectorProperties.connections.length;

  return (
    <Flex direction="column" gap="8">
      <BigcommerceConnectOtp postConnectPath={postConnectPath} />
      <ConnectorNavigationGroup hasConnections={hasConnections} forSlug={CONNECTOR_SLUG} />
    </Flex>
  );
};

export const BigcommercePage = () => {
  const intl = useIntl();

  return (
    <ConnectorPageTemplate
      title={intl.formatMessage(MESSAGES.connectTitle, { connectorName: "BigCommerce" })}
      primaryContent={<BigcommerceConnectWithNav />}
    />
  );
};
